// src/hooks/useScrollMemory.js
import { useEffect } from "react";
import { useLocation, useNavigationType } from "react-router-dom";

export const useScrollMemory = () => {
    const location = useLocation();
    const navigationType = useNavigationType();
    const key = `scrollPosition-${location.pathname}`;

    // 🔹 Постоянно сохраняем позицию при скролле (а не при размонтировании)
    useEffect(() => {
        const handleScroll = () => {
            sessionStorage.setItem(key, String(window.scrollY));
        };
        window.addEventListener("scroll", handleScroll);
        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, [key]);

    // 🔹 Восстанавливаем при возврате
    useEffect(() => {
        const savedPosition = sessionStorage.getItem(key);

        const restoreScroll = (top) => {
            requestAnimationFrame(() => {
                window.scrollTo({ top, behavior: "auto" });
            });
        };

        const waitForReady = (callback) => {
            if (document.readyState === "complete") {
                callback();
            } else {
                window.addEventListener("load", callback, { once: true });
            }
        };

        if (navigationType === "POP" && savedPosition) {
            waitForReady(() => {
                const top = parseInt(savedPosition, 10);
                restoreScroll(top);
            });
        } else {
            requestAnimationFrame(() => window.scrollTo({ top: 0, behavior: "auto" }));
        }
    }, [location.pathname, navigationType]);
};
